import { ErrorHandler, Injectable } from '@angular/core';
import posthog from 'posthog-js';

/**
 * Sends errors caught by Angular (templates, lifecycle hooks, subscriptions) to PostHog Error Tracking.
 * Uncaught errors outside Angular (window.onerror, unhandled rejections) are captured by
 * `capture_exceptions` (initPosthog in main.ts), since the app is zoneless and has no global error listeners.
 */
@Injectable()
export class PosthogErrorHandler extends ErrorHandler {
  override handleError(error: unknown): void {
    if (posthog.__loaded) {
      posthog.captureException(error);
    }
    super.handleError(error);
  }
}
